import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=135028b4&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=135028b4&prod&lang=scss&scoped=true"
import style1 from "./SidebarItem.vue?vue&type=style&index=1&id=135028b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135028b4",
  null
  
)

export default component.exports